import { render, staticRenderFns } from "./ThankYouLayoutChurch.vue?vue&type=template&id=91ff8650&"
import script from "./ThankYouLayoutChurch.vue?vue&type=script&lang=js&"
export * from "./ThankYouLayoutChurch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports